import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROLES, USER_TYPES } from 'src/app/constant/constant';
import { UserRoleAuthorizeGuard } from 'src/app/guards/user-role-authorize.guard';
import { AuthEgdGuard } from '../../../guards/auth-egd.guard';
import { UserCreateComponent } from './user-create/user-create.component';
import { UserListComponent } from './user-list/user-list.component';
import { MedicalProfessionDashboardComponent } from '../shared/medical-profession-dashboard/medical-profession-dashboard.component';
import { ConsultDoctorSupportComponent } from './consult-doctor-support/consult-doctor-support.component';
import { ViewDetailsComponent } from './view-details/view-details.component';
import { AppointmentsComponent } from '../shared/appointments/appointments.component';
import { ScheduleComponent } from '../shared/schedule/schedule.component';
import { PatientviewComponent } from '../../shared/patient-view/patientview/patientview.component';
import { UploadDocumentsSupportComponent } from './upload-documents-support/upload-documents-support.component';

const userTypes = USER_TYPES;

const routes: Routes = [
  {
    path: `:slug/${userTypes['SUPPORT']}`,
    component: MedicalProfessionDashboardComponent,
    canActivate: [UserRoleAuthorizeGuard],
    canActivateChild: [UserRoleAuthorizeGuard, AuthEgdGuard],
    data: { role_type: 'support', sub_role: [ROLES['Support']] },
    children: [
      {
        path: 'dashboard',
        canActivate: [UserRoleAuthorizeGuard],
        component: UserListComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'create-user',
        canActivate: [UserRoleAuthorizeGuard],
        component: UserCreateComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: 'fetch-list',
        canActivate: [UserRoleAuthorizeGuard],
        component: UserListComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: 'create-consultation',
        canActivate: [UserRoleAuthorizeGuard],
        component: ConsultDoctorSupportComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: 'view-details/:req_id',
        canActivate: [UserRoleAuthorizeGuard],
        component: ViewDetailsComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: 'appointments',
        canActivate: [UserRoleAuthorizeGuard],
        component: AppointmentsComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: 'schedules',
        canActivate: [UserRoleAuthorizeGuard],
        component: ScheduleComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: 'appointments/patient-view/:patient_guid/:consultation_id',
        canActivate: [UserRoleAuthorizeGuard],
        component: PatientviewComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      },
      {
        path: 'upload-documents/:patient_guid/:consultation_id/:isSupport',
        canActivate: [UserRoleAuthorizeGuard],
        component: UploadDocumentsSupportComponent,
        data: { role_type: 'support', sub_role: [ROLES['Support']] }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupportRoutingModule {}
